// File: src/components/common/ScrollAnimation.js

import React, { useEffect, useRef, useState } from 'react';

/**
 * Premium scroll-triggered animation.
 * Slower, more deliberate easing for an agency feel.
 */
function ScrollAnimation({
  children,
  delay = 0,
  threshold = 0.12,
  className = '',
  as: Tag = 'div',
  style: styleProp = {},
  distance = 48,
  duration = 1.0,
}) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(node);
        }
      },
      { threshold }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold]);

  const baseStyle = {
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : `translateY(${distance}px)`,
    transition: `opacity ${duration}s cubic-bezier(0.16, 1, 0.3, 1) ${delay}ms, transform ${duration}s cubic-bezier(0.16, 1, 0.3, 1) ${delay}ms`,
    willChange: 'opacity, transform',
    ...styleProp,
  };

  return (
    <Tag ref={ref} className={className} style={baseStyle}>
      {children}
    </Tag>
  );
}

export default ScrollAnimation;